<script setup lang="ts">
import PhIconButton from '@/components/ui/PhIconButton.vue'
import useLanguage from '@/composables/useLanguage'
import { PhX } from '@phosphor-icons/vue'

withDefaults(
  defineProps<{
    /** How large should the button be? */
    sizePixel?: number
    /** What color should the button be? */
    color?: 'default' | 'inverse'
    /** In which direction should the tooltip appear with respect to the button? */
    toolTipDirection?: 'left' | 'right' | 'top' | 'bottom'
    /** What text should the tooltip display (if undefined, default is "close")? */
    toolTipText?: string
    /** What should the aria-text be for the button, if different from the tooltip text? */
    ariaLabel?: string
  }>(),
  {
    sizePixel: 24,
    toolTipDirection: 'left',
    color: 'default'
  }
)

defineEmits<{
  (e: 'close'): void
}>()

const i18n = useLanguage('UICloseButton')
</script>

<template>
  <PhIconButton
    :tooltip-text="toolTipText || i18n.close"
    :tooltip-direction="toolTipDirection"
    tooltip-alignment="center"
    class="shrink-0"
    :label="ariaLabel ?? toolTipText ?? i18n.close"
    data-testid="close-btn"
    @click="$emit('close')"
  >
    <PhX
      :size="sizePixel"
      :class="color === 'default' ? 'fill-charcoal' : 'fill-white'"
      weight="regular"
    />
  </PhIconButton>
</template>
